import type { TuningBank } from '../schema/tuning';
export default { featureTankMinShadow: 6 } as const satisfies TuningBank;
